module.exports = __webpack_public_path__ + "static/img/2.12b5e160.png";